module.exports = __webpack_public_path__ + "static/img/banner-mobile.7f6f587e.svg";